import axios from 'axios';
import router from './router'
import {globalStore} from "./main.js"

export class getData {

    constructor(userProfile, getConstants) {
        if (typeof getConstants != 'undefined') {
            this.getConstants();
            this.getMapData();
        }
    }

    getConstants() {
        axios.get(globalStore.config.api_location + '/vessel/constants', {headers: {Authorization: globalStore.auth_token}}).then(response => {
            if (response.data.success) {
                globalStore.limits = response.data.data.limits;
                globalStore.mapping = response.data.data.mapping;
                globalStore.units = response.data.data.units;
                globalStore.faultMapping = response.data.data.faultParams;
            } else {
                globalStore.limits = {};
                globalStore.mapping = {};
                globalStore.units = {};
                globalStore.faultMapping = {};
            }
        });
    }

    async getDashboardData(date, dateTo) {
        var url = globalStore.config.api_location + '/shipco/dashboard/';

        if (typeof dateTo == 'string') {
            url += date + '/' + dateTo
        }

        axios.get(url, {headers: {Authorization: globalStore.auth_token}}).then((response) => {
            globalStore.dashboard = response.data.data;
        });
    }

    async getMapData() {
        axios.get(globalStore.config.api_location + '/vessel/map', {headers: {Authorization: globalStore.auth_token}}).then(response => {
            globalStore.mapData = response.data.data;
        });
    }

    async checkDate(date, imo) {
        document.body.style.cursor = 'progress';

        globalStore.checkedDate = false;
        globalStore.validDate = false;

        if (imo == '') {
            const response = await axios.get(globalStore.config.api_location + '/checkFleetExistenceData/' + date, {headers: {Authorization: globalStore.auth_token}})
                .catch(error => {
                    let logout = true;

                    if ((date != 'last') && (date != 'today')) {
                        let dt = new Date(date);
                        let today = new Date();

                        if (dt >= today) logout = false
                    }

                    if (logout) {
                        window.$cookies.set('login', 'Your connection to the application has expired');
                        globalStore.userLogged = false;
                        window.$cookies.remove('user');
                        location.reload(true);
                    } else {
                        globalStore.validDate = false;
                        globalStore.checkedDate = true;
                        document.body.style.cursor = 'default';
                    }
                });

            if (response.status == 200) {
                if (typeof response.data.success != 'undefined' && !response.data.success) {
                    window.$cookies.set('login', 'Your connection to the application has expired');
                    globalStore.userLogged = false;
                    window.$cookies.remove('user');
                    location.reload(true);
                } else {
                    let tmp = response.data.data;

                    globalStore.availableVessels = [];

                    for (let v = 0; v < Object.keys(tmp).length; v++) {
                        let key = Object.keys(tmp)[v];

                        if (tmp[key])
                            globalStore.availableVessels.push(key);
                    }

                    if (globalStore.availableVessels.length > 0) {
                        globalStore.validDate = true;
                        globalStore.checkedDate = true;
                        document.body.style.cursor = 'default';
                    } else {
                        globalStore.validDate = false;
                        globalStore.checkedDate = true;
                        document.body.style.cursor = 'default';
                    }
                }
            }
        } else {
            let response = await axios.get(globalStore.config.api_location + '/checkFleetExistenceData/' + date, {headers: {Authorization: globalStore.auth_token}})
                .catch(error => {
                    let logout = true;

                    if (date != 'last' && date != 'today') {
                        let dt = new Date(date);
                        let today = new Date();

                        if (dt >= today) logout = false
                    }

                    if (logout) {
                        window.$cookies.set('login', 'Your connection to the application has expired');
                        globalStore.userLogged = false;
                        window.$cookies.remove('user');
                        location.reload(true);
                    } else {
                        globalStore.validDate = false;
                        globalStore.checkedDate = true;
                        document.body.style.cursor = 'default';
                    }
                });

            if (response.status == 200) {
                if (typeof response.data.success != 'undefined' && !response.data.success) {
                    window.$cookies.set('login', 'Your connection to the application has expired');
                    globalStore.userLogged = false;
                    window.$cookies.remove('user');
                    location.reload(true);
                } else {
                    let tmp = response.data.data;

                    globalStore.availableVessels = [];

                    for (let v = 0; v < Object.keys(tmp).length; v++) {
                        let key = Object.keys(tmp)[v];

                        if (tmp[key])
                            globalStore.availableVessels.push(key);
                    }
                }
            }

            response = await axios.get(globalStore.config.api_location + '/checkExistenceData/' + imo + '/' + date, {headers: {Authorization: globalStore.auth_token}})
                .catch(error => {
                    globalStore.validDate = false;
                    globalStore.checkedDate = true;
                    document.body.style.cursor = 'default';
                });

            if (response.status == 200) {
                if (response.data.data) {
                    globalStore.validDate = true;
                    globalStore.checkedDate = true;
                    document.body.style.cursor = 'default';
                } else {
                    globalStore.validDate = false;
                    globalStore.checkedDate = true;
                    document.body.style.cursor = 'default';
                }
            }
        }
    }

    async getData(date, imo) {
        document.body.style.cursor = 'progress';

        globalStore.type = '';

        if (!!!date) {
            date = 'last';
        }

        if (imo != '') {
            var url = globalStore.config.api_location + '/vessel/GetVesselInfo/' + imo + '/' + date;
            console.log(url)
            await axios.get(url, {headers: {Authorization: globalStore.auth_token}}).then(response => {
                try {
                    globalStore.loadDiagram = response.data.data['load_diagram'];

                    this.parseShopData(response.data.data['shop_test_data']);

                    if (globalStore.twinEngine) {
                        globalStore.twinSignals = response.data.data.signal;
                        globalStore.twinReference = response.data.data.reference;
                        globalStore.twinFaults = response.data.data.faults;

                        globalStore.twinFaults = {
                            'Port': Object.values(response.data.data.faults.Port).map(function (item) {
                                if (typeof item != 'object') {
                                    return (typeof item == 'string' ? JSON.parse(item) : item);
                                } else {
                                    return item;
                                }
                            }),
                            'Stbd': Object.values(response.data.data.faults.Stbd).map(function (item) {
                                if (typeof item != 'object') {
                                    return (typeof item == 'string' ? JSON.parse(item) : item);
                                } else {
                                    return item;
                                }
                            })
                        };

                        if (globalStore.selectedEngine != '') {
                            globalStore.signals = globalStore.twinSignals[globalStore.selectedEngine];
                            globalStore.reference = globalStore.twinReference[globalStore.selectedEngine];
                            this.checkEngineStatus(globalStore.twinSignals[globalStore.selectedEngine]);
                        } else {
                            this.checkEngineStatus(globalStore.twinSignals['Port']);
                        }
                    } else {
                        globalStore.signals = response.data.data.signal;
                        globalStore.reference = response.data.data.reference;

                        this.parseFaults(response.data.data.faults);
                        this.checkEngineStatus(globalStore.signals);
                    }

                    globalStore.MyEvent.fire('vesselDataLoaded');
                } catch (e) {
                    globalStore.loadDiagram = {};
                    globalStore.signals = {};
                    globalStore.reference = {};
                    globalStore.twinSignals = {};
                    globalStore.twinReference = {};
                    globalStore.faults = {};
                    globalStore.chartData = {};
                }
            });

            globalStore.type = date;
        } else {
            this.getDashboardData(date);

            globalStore.type = date;
        }

        document.body.style.cursor = 'default';
    }

    parseFaults(faultsTmp) {
        var data = faultsTmp;

        if (typeof data['Port'] != 'undefined')
            data = data['Port'];

        let faultDict = data;

        if (faultDict.length) {
            var faults = faultDict.map(function (item) {
                if (typeof item != 'object') {
                    item = JSON.parse(item);
                }

                item.startDate = item.startDate.replace('T', ' ');
                item.endDate = item.endDate.replace('T', ' ');

                return item;
            });

            faults = faults.sort(function (a, b) {
                return new Date(a.endDate) - new Date(b.endDate);
            });

            globalStore.faults = faults;
        } else
            globalStore.faults = [];
    }

    parseShopData(shop_test_data) {
        if (globalStore.twinEngine) {
            shop_test_data = shop_test_data['Port'];
        }

        let keys = Object.keys(shop_test_data),
            elementNo = shop_test_data.elementNo;

        keys.splice(keys.indexOf('elementNo'), 1);

        for (let i = 0; i < keys.length; i++) {
            globalStore.chartData[keys[i]] = shop_test_data[keys[i]];
        }

        globalStore.cylCount = elementNo.cylNo;
        globalStore.tcCount = elementNo.tcNo;
    }

    checkEngineStatus(signals) {
        let timestamp = signals['lastDate'];

        if (signals[timestamp]) {
            let stateText = signals[timestamp]['engineStateText'];

            if (stateText == undefined) {
                if (signals[timestamp]['engineState'] == -1000)
                    router.push({path: 'dashboard'});
            } else {
                if ((stateText != 'Running') && (stateText != 'Slowdown'))
                    router.push({path: 'dashboard'});
            }
        }
    }

    async getUserNotifications() {
        axios.get(`${globalStore.config.api_location}/alerts/`, {headers: {Authorization: globalStore.auth_token}}).then(async response => {
            try {
                await localStorage.setItem('alerts', JSON.stringify(response.data.data));
                globalStore.alerts = response.data.data;
            } catch (e) {
                console.log(e);
            }
        }).catch((e) => {
            console.log(e);
        });
    }
}
